import VehicleTransferlModal from './vehicle-transferl-modal.vue'
export default VehicleTransferlModal
